<div>
    <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>   
<div class="d-flex justify-content-end">          
    <div *ngIf="!isRenew() && !isBulkRenew()" class="float-end">
         <button id="topcompleteOrder" type="submit" class="btn btn-primary me-3" appPreventDoubleClick
            [throttleTime]="3000" (throttledClick)="submitForm($event)">
            Complete Order
        </button>
        <button id="topcanOrder" class="btn btn-secondary" type="button" (click)="cancelOrder()">
            {{ isPayLater() || isManualPayMonthlyBilling() ? "Cancel" : "Clear Order" }}
        </button>
      </div>
      <div *ngIf="isRenew() || isBulkRenew()" class="float-end">
            <button id="topcompleteOrder" type="button" class="btn btn-primary me-3" appPreventDoubleClick
            [throttleTime]="700" (throttledClick)="submitForm($event)">
            Complete Renew
        </button>
        <button i18n class="btn btn-secondary" type="button" (click)="cancelOrder()" id="topcanOrder">
            Cancel Renew
        </button>
    </div>
</div>  
<h3 i18n> Review My Order </h3>

<form #f="ngForm" (ngSubmit)="submit(f)" (keydown.enter)="handleEnter($event)" [ngClass]="{ unsubmitted: !f.submitted }"
    [appMustMatch]="['accountNumber', 'confirmAccountNumber']">
    <p-table styleClass="p-datatable-striped" *ngIf="!isManualPayMonthlyBilling()" [columns]="tableColumn" [value]="leasesForDisplay">
        <ng-template pTemplate="header" let-columns>
            <tr *ngIf="leasesForDisplay.length > 0">
                <th [style.width.%]="col.width" *ngFor="let col of columns" class="noBorder" [ngClass]="col.field">
                    {{ col.header }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field" [ngClass]="col.field">
                    <div *ngSwitchDefault>{{ rowData[col.field] }}</div>
                    <div *ngSwitchCase="'term'">
                        {{rowData.term | termLength: rowData.leaseType}}
                    </div>
                    <div *ngSwitchCase="'scId'">
                        {{ rowData[col.field] }} <span *ngIf="rowData.ANString">({{rowData?.ANString}})</span>
                    </div>
                    <div *ngSwitchCase="'price'">
                        <span
                            *ngIf="!isRenew1Plus12() ||
                                    (isRenew1Plus12() && payNow) ||
                                    (isRenew1Plus12() && !payNow && rowData.leaseType !== 'BilledMonthly') ||
                                    (isRenew1Plus12() && !payNow && rowData.leaseType === 'BilledMonthly' && getDiscountList(rowData).length === 0 )">
                            {{ rowData[col.field] | currency }}
                        </span>
                        <span
                            *ngIf="isRenew1Plus12() && !payNow && getDiscountList(rowData).length >0 && rowData.leaseType === 'BilledMonthly'">
                            To Be Determined
                        </span>
                    </div>
                    <div *ngSwitchCase="'shortCodeType'">
                        {{ rowData.selectType }}
                    </div>
                    <div *ngSwitchCase="'discount'">
                        <span *ngIf="(!isRenew1Plus12() ||
                                      (isRenew1Plus12() && payNow) ||
                                      (isRenew1Plus12() && !payNow && rowData.leaseType !== 'BilledMonthly') ) &&
                                      (rowData.discountAmount || getDiscountList(rowData).length >0 )">
                            {{ getDiscountList(rowData) }} <span *ngIf="rowData.discountAmount">({{
                                rowData.discountAmount | currency }}) </span>
                        </span>
                        <span *ngIf="isRenew1Plus12() &&
                                        !payNow &&
                                        rowData.leaseType === 'BilledMonthly' &&
                                        (rowData.discountAmount || getDiscountList(rowData).length >0 )">
                            To Be Determined
                        </span>
                    </div>
                    <div *ngSwitchCase="'listPrice'">
                        {{ rowData.listPrice | currency }}
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length" class="noBorder" style="background-color: #EEF7F7;">
                    <p><small>Since there are no codes in the cart, please cancel this renew and start over.</small></p>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div *ngIf="isManualPayMonthlyBilling()">
        <br />
        <h5><b>Invoice {{ pendingOrder.orderId}}</b></h5>
        <h5><b>Total Codes in Monthly Invoice: {{ pendingOrder.lines.length }}</b></h5>
    </div>
    <div *ngIf="!isRenew1Plus12()">
        <h5>
            <b>Total: {{ pendingOrder.totalPrice | currency }}</b>
        </h5>
        <h5 *ngIf="applyCredit === true">
            <b><span>Credit:</span> ({{creditToBeApplied | currency}}) <span>Credit on Account will be applied to this payment</span></b>
        </h5>
        <h5 *ngIf="applyCredit === true">
            <b><span>Amount Due:</span> {{amountDueAfterCredit | currency}} </b>
        </h5>
    </div>
    <div *ngIf="isRenew1Plus12() && ( payNow || ( !payNow && getDiscountList(pendingOrder.leases[0]).length === 0 ) )">
        <h5><b>Total: {{ pendingOrder.totalPrice | currency }} ({{ leasesForDisplay[0].price | currency}} to be paid in
                monthly installments of {{ (leasesForDisplay[0].price || 0)/12 | currency}}.)</b></h5>

        <h5 *ngIf="applyCredit === true">
            <b><span>Credit:</span> ({{creditToBeApplied | currency}}) <span>Credit on Account will be applied to this payment</span></b>
        </h5>

        <h5 *ngIf="applyCredit === true"><b>Due Now: {{amountDueAfterCredit | currency}} (Must be paid by {{
                pendingOrder.renewalDeadLineStr}}
                for the lease to automatically roll over into Monthly Billing.)</b></h5>

        <h5 *ngIf="applyCredit !== true"><b>Due Now: {{leasesForDisplay[1].price | currency}} (Must be paid by {{
                pendingOrder.renewalDeadLineStr}}
                for the lease to automatically roll over into Monthly Billing.)</b></h5>
    </div>
    <div *ngIf="isRenew1Plus12() && !payNow && getDiscountList(pendingOrder.leases[0]).length>0 ">
        <h5><b>Total: To Be Determined</b></h5>
        <h5><b>Due Now: {{leasesForDisplay[1].price | currency}} (Must be paid by {{ pendingOrder.renewalDeadLineStr}}
                for the lease to automatically roll over into Monthly Billing.)</b></h5>
    </div>
    <div *ngIf="paymentModeDebug">
        {{getOrderTransactionType()}}
    </div>
    <small *ngIf="showPayWithCreditAfterCheckBoxSelection()">
        Your account has credit in the amount of {{ credit | currency }}.<br />
        To pay using this credit, select Apply Credit on Account, below.
    </small>
    <ng-template [appAuthIf]="[CognitoGroup.Registrant]">
        <div *ngIf="!isRenewDirectIntoMB()">
            <hr />

            <h3 class="mb-4"> Payment Information </h3>
            <div class="mb-3" *ngIf="(credit !== 0) && supportsPayWithCredit()">
                <p-checkbox id="applyCreditOnAccount" [label]="'Apply Credit on Account: ' + minOfCreditAndTotal"
                    [binary]='true' [(ngModel)]="applyCredit" name="applyCreditOnAccount" (click)="updateAmountDue()"
                    [disabled]="!payNow">
                </p-checkbox>
                <small class="ms-3 mt-2">Account credit will be applied to the total at the time of payment. Any
                    remaining amount due will be paid with the payment method selected below.</small>
            </div>

            <p-radioButton id="pn" label="Pay Now" [value]="true" [(ngModel)]="payNow" name="pn"
                (click)="showRenew1Plus12Warning()"
                [disabled]="isPayLater() || isManualPayMonthlyBilling() || applyCredit">
            </p-radioButton>
            <p-radioButton id="pn"
                [disabled]="isPayLater() || isManualPayMonthlyBilling() || applyCredit"
                label="Pay Later" [value]="false" [(ngModel)]="payNow" class="ms-5" name="pn"
                (click)="showRenew1Plus12Warning()"></p-radioButton>

            <div class="ms-5 mt-2" *ngIf="payNow && !noPaymentDue">
                <div *ngFor="let ach of achs" class="mt-2">
                    <p-radioButton [label]="achSummary(ach)" [value]="ach.achPaymentMethodId"
                        [(ngModel)]="selectedPayment" [name]="'card'+ach.achPaymentMethodId" (onClick)="clearNewPM()">
                    </p-radioButton>
                </div>
                <div *ngFor="let card of cards" class="mt-2">
                    <p-radioButton [label]="cardSummary(card)" [value]="card?.creditCardId" (onClick)="clearNewPM()"
                        [(ngModel)]="selectedPayment" [name]="'card'+card?.creditCardId" [disabled]="isExpired(card)">
                    </p-radioButton>
                </div>
                <div class="mt-2">
                    <p-radioButton label="New Payment Method" [value]="true" [(ngModel)]="newPaymentMethod"
                        name="newPaymentMethod" id="newPaymentMethod" (onClick)="newPaymentMethodSetup()">
                    </p-radioButton>
                </div>
                <div class="mt-2 ms-4" *ngIf="newPaymentMethod">
                    <p-radioButton label="Credit Card" [value]="0" [(ngModel)]="selectedPayment" name="cardId"
                        id="cardId">
                    </p-radioButton>
                    &nbsp;
                    <p-radioButton label="ACH" [value]="1" [(ngModel)]="selectedPayment" name="achId"
                        id="achId"></p-radioButton>
                </div>
                <div class="ms-5 mt-4" *ngIf="selectedPayment === 0">
                    <div>
                        <div class="row">
                            <div class="col-7 mb-3">
                                <label for="description">Description</label>
                                <input id="description" appScrText placeholder="Description" name="description"
                                    [(ngModel)]="newcard.description" maxlength="30" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3 mb-3">
                                <label for="cardType" class="required">Card Type</label>
                                <p-dropdown appDd [filter]="true" [options]="cardTypes" placeholder="Card Type"
                                    [required]="true" [(ngModel)]="newcard.cardType" #cardType="ngModel" name="cardType"
                                    id="cardType"></p-dropdown>
                                <app-error-msg [field]="cardType" fieldLabel="Card Type"></app-error-msg>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 mb-3">
                                <label for="ccNumber" class="required">Credit Card Number</label>
                                <input appScrText appCcValidator [cardType]="newcard.cardType"
                                    [mask]="newcard.cardType === 'Amex' ? '0000 000000 00000' : '0000 0000 0000 0000'"
                                    [validation]="false" [(ngModel)]="newcard.creditCardNumber" #ccNumber="ngModel"
                                    name="ccNumber" placeholder="Credit Card Number" required id="ccNumber" />
                                <app-error-msg [field]="ccNumber" fieldLabel="Credit Card Number"></app-error-msg>
                            </div>
                        </div>

                        <h5 class="mb-2">Expiration Date</h5>
                        <div class="row">
                            <div class="col-3">
                                <label for="month" class="required">Month</label>
                                <p-dropdown appDd [filter]="true" [options]="months" placeholder="Month"
                                    [(ngModel)]="newcard.expirationMonth" name="month" #month="ngModel"
                                    [required]="true" appCcExpirationValidator [year]="newcard.expirationYear"
                                    id="month">
                                </p-dropdown>
                                <app-error-msg [field]="month" fieldLabel="Month" *ngIf="!newcard.expirationMonth">
                                </app-error-msg>
                            </div>
                            <div class="col-2">
                                <label for="year" class="required">Year</label>
                                <p-dropdown appDd [filter]="true" [options]="years" placeholder="Year"
                                    [(ngModel)]="newcard.expirationYear" name="year" #year="ngModel" [required]="true"
                                    appCcExpirationValidator [month]="newcard.expirationMonth" id="year"></p-dropdown>
                                <app-error-msg [field]="year" fieldLabel="Year"></app-error-msg>
                            </div>
                        </div>
                        <div class="mb-3">
                            <app-error-msg [field]="month" *ngIf="newcard.expirationMonth"></app-error-msg>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label for="cvv" class="required">Card Verification Value (CVV)
                                    <sup><i class="fa fa-circle-info large" style="color: #004381; margin-left: .1em;"
                                        pTooltip="For your safety and security, we require that you enter your card verification number.
                                For Visa, MasterCard, and Discover cards, the card verification number is the last 3 digit number located on the back of your 
                                card on or above your signature line. For an American Express card, it is the 4 digits on the front above the end of your card number."
                                        tooltipPosition="top" tooltipStyleClass="toolCardData"></i></sup>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3 mb-3">
                                <!-- <label class="required">Card Verification</label> -->
                                <input appScrText appCvvValidator mask="9999" [validation]="false"
                                    [cardType]="newcard.cardType" placeholder="CVV" [(ngModel)]="newcard.cvv" name="cvv"
                                    #cvv="ngModel" required id="cvv" />
                                <app-error-msg [field]="cvv" fieldLabel="Card Verification Value (CVV)"></app-error-msg>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 mb-3">
                                <p-checkbox label="Add Card to Profile after Checkout" [(ngModel)]="addToProfile"
                                    name="addToProfile" (onChange)="addToProfileUpdate($event)" [binary]="true"
                                    id="addToProfile"></p-checkbox>
                                <div class="ms-4 mt-2">
                                    Check this box if you wish to update your credit card profile with the information
                                    above.
                                </div>
                                <div class="ms-5 mt-2">
                                    <p-checkbox [disabled]="!addToProfile" label="Set as Default" [(ngModel)]="default"
                                        name="default" [binary]="true" id="default"></p-checkbox>
                                    <div class="ms-4 mt-2">
                                        If you set this new credit card as the default, all your
                                        Auto-renew orders will be charged using the new credit
                                        card profile information.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ms-5 mt-4" *ngIf="selectedPayment === 1">
                    <div>
                        <div class="row">
                            <div class="col-8 mb-2">
                                You must notify your bank that iconectiv is approved to electronically debit your
                                account for payments
                                to the Short Code Registry. Please provide your bank with iconectiv’s identification
                                code ({{achIdentificationCode}}),
                                which will be associated with these debited payments. Failure to do so may result in the
                                payment being
                                declined and the order being reverted to an unpaid state.

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-7 mb-3">
                                <label id="accountOwnerNameLabel" for="accountOwnerName" class="required">Account Owner
                                    Name</label>
                                <input class="form-control" appScrText [(ngModel)]="newach.accountOwnerName"
                                    id="accountOwnerName" #accountOwnerName="ngModel" name="accountOwnerName"
                                    placeholder="Account Owner Name" [required]="true" maxlength="80" />
                                <app-error-msg [field]="accountOwnerName"
                                    fieldLabel="Account Owner Name"></app-error-msg>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3 mb-3">
                                <label for="accountTypeDD" class="d-block" id="accountTypeLabel" class="required">Account
                                    Type</label>
                                <p-dropdown appDd [options]="accountTypes" [filter]="true"
                                    name="accountType" placeholder="Account Type" [(ngModel)]="newach.accountType"
                                    [required]="true" name="accountType" id="accountTypeDD" #accountType="ngModel">
                                </p-dropdown>
                                <app-error-msg [field]="accountType" fieldLabel="Account Type"></app-error-msg>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-7 mb-3">
                                <label id="descriptionLabel" for="description">Description</label>
                                <input id="description" appScrText placeholder="Description" name="description"
                                    name="description" [(ngModel)]="newach.description" maxlength="80" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 mb-3">
                                <label id="accountNumberLabel" for="accountNumber" class="required">Account
                                    Number</label>
                                <input class="form-control" appScrText maxlength="{{MaxLen.AccountNumber}}"
                                    minlength="6" name="accountNumber" placeholder="Account Number" appNumericOnly
                                    id="accountNumber" [(ngModel)]="newach.accountNumber" #accountNumber="ngModel"
                                    [required]="true" />
                                <app-error-msg [field]="accountNumber" fieldLabel="Account Number"
                                    [customLengthMessage]="true"
                                    customLengthMessageContent="Account Number is invalid. Must be between 6-17 digits.">
                                </app-error-msg>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 mb-3">
                                <label id="confirmAccountNumberLabel" for="confirmAccountNumber"
                                    class="required">Confirm Account Number</label>
                                <input class="form-control" appScrText maxlength="{{MaxLen.AccountNumber}}"
                                    minlength="6" #confirmAccountNumber="ngModel" placeholder="Confirm Account Number"
                                    appNumericOnly [(ngModel)]="newach.confirmAccountNumber" name="confirmAccountNumber"
                                    id="confirmAccountNumber" [required]="true" />
                                <app-error-msg [field]="confirmAccountNumber" fieldLabel="Confirm Account Number"
                                    [customLengthMessage]="true"
                                    customLengthMessageContent="Confirm Account Number is invalid. Must be between 6-17 digits.">
                                </app-error-msg>
                                <div>
                                    <span class="inline-error-text" *ngIf="((newach.accountNumber !== newach.confirmAccountNumber) && f.submitted && newach.confirmAccountNumber !== '') && !f.controls.confirmAccountNumber.errors?.required
                                        && !f.controls.confirmAccountNumber.errors?.minlength">
                                        Value must match the value entered in Account Number
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-7 mb-3">
                                <label id="routingNumberLabel" for="routingNumber" class="required">Routing Number (9
                                    Digits)</label>
                                <input class="form-control" appScrText appCheckSum appNumericOnly
                                    #routingNumber="ngModel" name="routingNumber" placeholder="Routing Number"
                                    minlength="9" id="routingNumber" maxlength="{{MaxLen.RoutingNumber}}"
                                    [(ngModel)]="newach.routingNumber" [required]="true" />
                                <app-error-msg [field]="routingNumber" fieldLabel="Routing Number"></app-error-msg>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-7 mb-3">
                                <label id="bankNameLabel" for="bankName" class="required">Bank Name</label>
                                <input class="form-control" appScrText placeholder="Bank Name" #bankName="ngModel"
                                    id="bankName" name="bankName" maxlength="40" [(ngModel)]="newach.bankName"
                                    [required]="true" />
                                <app-error-msg [field]="bankName" fieldLabel="Bank Name"></app-error-msg>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 mb-3">
                                <label id="maxPaymentLimitLabel" for="maxPaymentLimit" class="required">Maximum Payment
                                    Limit</label>

                                <p-inputNumber appIn #limit="ngModel" [(ngModel)]="newach.limit"
                                    mode="currency" currency="USD" locale="en-US" [min]="0.01" [required]="true"
                                    name="limit" [max]="achMaxPaymentLimit" placeholder="Maximum Payment Limit"
                                    id="maxpaymentLimit"></p-inputNumber>
                                <app-error-msg [field]="limit" fieldLabel="Maximum Payment Limit"></app-error-msg>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 mb-3">
                                <p-checkbox label="Add Payment Method to Profile after Checkout"
                                    [(ngModel)]="addToProfile" name="addToProfile"
                                    (onChange)="addToProfileUpdate($event)" [binary]="true" id="addToProfile">
                                </p-checkbox>
                                <div class="ms-4 mt-2">
                                    Check this box if you wish to update your payment methods on file with the
                                    information above.
                                </div>
                                <div class="ms-5 mt-2">
                                    <p-checkbox [disabled]="!addToProfile" label="Set as Default" [(ngModel)]="default"
                                        name="default" [binary]="true" id="default"></p-checkbox>
                                    <div class="ms-4 mt-2">
                                        If you set this new payment method as the default, all your
                                        Auto-renew orders will be charged using this payment method.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8 mb-3">
                                <label for='consent' class="required" id="consentLabel">
                                    <p-checkbox label="Consent" [(ngModel)]="newach.consent" name="consent"
                                        [binary]="true" id="consent" [required]="true" #consent="ngModel"></p-checkbox>
                                </label>
                                <div *ngIf="consent.errors?.required && f.submitted" class="mb-3 col-md-14">
                                    <span class="failed">Please read the Consent
                                        Agreement regarding ACH withdrawals and click on the box to accept.</span>
                                </div>
                                <div class="ms-4 mt-2 small">
                                    I hereby authorize the payee to electronically debit my bank account for payments to
                                    the Short Code Registry not to exceed the amount
                                    specified as the Maximum Payment Limit.
                                    <br>
                                    <br>
                                    If a convenience fee is added to the transaction, I understand that the convenience
                                    fee will be included in the total payment amount.
                                    <br>
                                    <br>
                                    If a payment is returned for insufficient funds, I authorize the payee to
                                    electronically debit my account for the original amount of
                                    the transaction, as well as a returned item fee, up to the maximum amount allowed by
                                    law.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-2" *ngIf="!payNow">
                Use the Pay Now option if you want to use your code(s) immediately.<br />
                Carriers require a Sales Receipt, which can be issued only when payment is complete.
            </div>
        </div>
    </ng-template>
    <div *ngIf="!isRenewDirectIntoMB()">
        <hr />

        <h3> Billing Information </h3>

        <div class="my-4">
            <app-address-book (addressChosen)="loadAddress($event)"></app-address-book>
        </div>

        <div class="mt-2">
            <div class="row">
                <div class="col-5 mb-3">
                    <label for="firstName" class="required">First Name</label>
                    <input appScrText placeholder="First Name" id="firstName" name="firstName" #firstName="ngModel"
                        maxlength="{{MaxLen.FirstName}}" [(ngModel)]="pendingOrder.billingFirstName"
                        appFirstNameValidator required />
                    <app-error-msg [field]="firstName" fieldLabel="First Name"></app-error-msg>
                </div>
                <div class="col-5 mb-3">
                    <label for="lastName" class="required">Last Name</label>
                    <input appScrText placeholder="Last Name" id="lastName" name="lastName" #lastName="ngModel"
                        maxlength="{{MaxLen.LastName}}" [(ngModel)]="pendingOrder.billingLastName" appLastNameValidator
                        required />
                    <app-error-msg [field]="lastName" fieldLabel="Last Name"></app-error-msg>
                </div>
            </div>
            <div class="row">
                <div class="col-3 mb-3">
                    <label for="billingPhoneInput" class="required">Phone Number</label>
                    <app-phone required [(ngModel)]="pendingOrder.billingPhone" #billingPhone="ngModel" class="col-12" name="billingPhone" id="billingPhone"></app-phone>
                    <app-error-msg [field]="billingPhone" fieldLabel="Phone Number"></app-error-msg>
                </div>
                <div class="col-2 mb-3">
                    <label for="billingPhoneExt">Extension</label>
                    <input appScrText [(ngModel)]="pendingOrder.billingPhoneExtension" id="billingPhoneExt"
                        name="billingPhoneExt" maxlength="{{MaxLen.PhoneExtension}}">
                </div>
            </div>
            <div class="row">
                <div class="col-8 mb-3">
                    <label for="billingEmail" class="required">Email</label>
                    <input appScrText placeholder="Email" required appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" id="billingEmail"
                        name="billingEmail" #billingEmail="ngModel" [(ngModel)]="pendingOrder.billingEmail"
                        maxlength="{{MaxLen.Email}}" />
                    <app-error-msg [field]="billingEmail" fieldLabel="Email"></app-error-msg>
                </div>
            </div>
            <div class="row">
                <div class="col-4 mb-3">
                    <label for="country" class="required">Country</label>
                    <app-country-dropdown #country="ngModel" [(ngModel)]="pendingOrder.billingCountry" id="country"
                        name="country"></app-country-dropdown>
                    <app-error-msg [field]="country" fieldLabel="Country"></app-error-msg>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mb-3">
                    <label for="address1" class="required">Street Address 1</label>
                    <input appScrText placeholder="Street Address 1" #address1="ngModel" maxlength="{{MaxLen.Address}}"
                        [(ngModel)]="pendingOrder.billingAddress1" id="address1" name="address1" required />
                    <app-error-msg [field]="address1" fieldLabel="Street Address 1"></app-error-msg>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mb-3">
                    <label for="address2">Street Address 2</label>
                    <input appScrText placeholder="Street Address 2" #address2="ngModel" maxlength="{{MaxLen.Address}}"
                        [(ngModel)]="pendingOrder.billingAddress2" id="address2" name="address2" />
                    <app-error-msg [field]="address2" fieldLabel="Street Address 2"></app-error-msg>
                </div>
            </div>
            <div class="row">
                <div class="col-4 mb-3">
                    <label for="city" class="required">City</label>
                    <input appScrText placeholder="City" #city="ngModel" maxlength="{{MaxLen.City}}"
                        [(ngModel)]="pendingOrder.billingCity" id="city" name="city" required />
                    <app-error-msg [field]="city" fieldLabel="City"></app-error-msg>
                </div>
                <div class="col-4 mb-3">
                    <label for="state"
                        [ngClass]="{required: pendingOrder.billingCountry === 'us' || pendingOrder.billingCountry === 'ca'}">
                        State/Province
                    </label>
                    <app-region-dropdown [country]="pendingOrder.billingCountry" #state="ngModel"
                        [(ngModel)]="pendingOrder.billingState" id="state" name="state"></app-region-dropdown>
                    <app-error-msg [field]="state" fieldLabel="State/Province"></app-error-msg>
                </div>
                <div class="col-4 mb-3">
                    <label for="zipInput"
                        [ngClass]="{required: pendingOrder.billingCountry === 'us' || pendingOrder.billingCountry === 'ca'}">
                        Zip/Postal Code
                    </label>
                    <app-zipcode-input [country]="pendingOrder.billingCountry" #zip="ngModel" maxlength="{{MaxLen.Zip}}"
                        [(ngModel)]="pendingOrder.billingZip" id="zip" name="zip" inputId="zipInput"></app-zipcode-input>
                    <app-error-msg [field]="zip" fieldLabel="Zip/Postal Code"></app-error-msg>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!isRenewDirectIntoMB() && !monthlyInvoice.accountId">
        <hr />
        <h3 class="mb-4">Purchase Order (Optional) </h3>
        <div class="row">
            <div class="col-4 mb-3">
                <label for="poNumber">Purchase Order Number</label>
                <input appScrText placeholder="Purchase Order Number" id="poNumber" name="poNumber" #poNumber="ngModel"
                    [(ngModel)]="pendingOrder.poNumber" maxlength="{{MaxLen.PurchaseOrderNumber}}" />
            </div>
        </div>
    </div>
    <ng-template [appAuthIf]="[CognitoGroup.Registrant]">
        <div *ngIf="!isManualPayMonthlyBilling() && !isRenewIntoMB() && !ifRenew1Plus12DeadlinePassed()">
            <hr />
            <h3 class="mb-4"> Auto-Renew </h3>

            <p-checkbox label="I want to automatically renew the short code(s) in this order." name="enrollInAutoRenew"
                id="enrollInAutoRenew" [(ngModel)]="pendingOrder.enrollInAutoRenew" [binary]="true"></p-checkbox>
            <div class="ms-4 mt-2">
                I understand and agree that by checking this box, I authorize the Short Code Registry to charge my
                account for the applicable fee for renewal
                of this code for repeating leases, until I explicitly opt out of Auto-Renew for this code. I understand
                that if I have a default payment method on file,
                this payment method will be automatically charged the applicable fee; and that if I have no default
                payment method on file, my account is responsible
                to pay this fee by either credit card, ACH, check, or wire transfer. I also understand and agree that
                each renewal will be subject to the terms and
                conditions of short code Auto-Renew as described in the Registrant Sublicense Agreement to which I
                agreed upon order submission. Finally, I understand
                that there may be limitations regarding when I can opt out of Auto-Renew.
            </div>
        </div>
    </ng-template>
    <div *ngIf="(monthlyBilling || isRenewIntoMB() ) && !isManualPayMonthlyBilling() && !bulk">
        <hr />

        <h3 class="mb-4"> Monthly Billing </h3>
        <h5 class="mb-4 ms-4 autorenew-note">
            Auto-Renew is included in Monthly Billing.
        </h5>
        <div *ngIf="isRenewIntoMB()">
            <div *ngIf="isRenewDirectIntoMB()">
                <h5 class="mb-4 ms-4 autorenew-note" i18n>
                    <span>This short code will be considered renewed immediately upon the completion of this
                        renewal.</span>
                    <span>The short code will be billed monthly starting {{pendingOrder.monBillStartDateStr}}.</span>
                </h5>
            </div>
            <div *ngIf="!isRenewDirectIntoMB()">
                <h5 class="mb-4 ms-4 autorenew-note" i18n>
                    <span>To add this short code to Monthly Billing, you must start with a 1-month pre-paid lease that
                        will automatically roll over into monthly billing.</span>
                    <span>The short code will be billed monthly starting {{pendingOrder.monBillStartDateStr}}.</span>
                </h5>
            </div>
            <label for='enrollInMonthlyBilling' class="required mt-0">
                <p-checkbox [(ngModel)]="pendingOrder.enrollInMonthlyBilling" [binary]="true"
                    id="enrollInMonthlyBilling" name="enrollInMonthlyBilling" #checkboxAgreement="ngModel"
                    [disabled]="isPayLater()" [required]="isRenewIntoMB()"
                    label="I want to renew this short code into Monthly Billing.">
                </p-checkbox>
            </label>
            <div class="error-msg" *ngIf="checkboxAgreement.touched && checkboxAgreement.invalid">
                <span class="failed" i18n>
                    You must either accept the Monthly Billing terms, or return to the Cart tab and select a 3-Month,
                    6-Month, or 12-Month term for this renewal.
                </span>
            </div>
            <div *ngIf="renewDirectBilledMonthly" class="mt-4 ms-4" i18n>
                I understand and agree that by checking this box,
                I authorize the Short Code Registry to bill this short code on a monthly basis,
                and that it will remain in Monthly Billing until I explicitly remove it.
                I also agree that this short code is subject to the terms of the Monthly Billing Program as described in
                the Registrant Sublicense Agreement.
            </div>
            <div *ngIf="isRenew1Plus12()">
                <div class="ms-4 mt-2" i18n>
                    I understand and agree that by checking this box,
                    I authorize the Short Code Registry to bill this short code on a monthly basis
                    following the completion of the initial pre-paid term,
                    and that the short code will remain in Monthly Billing until I explicitly remove it.
                    I also agree that this short code is subject to the terms of the Monthly Billing Program
                    as described in the Registrant Sublicense Agreement.
                </div>
            </div>
        </div>
        <div *ngIf="monthlyBilling">
            <p-checkbox
                label="I want to automatically renew the short code(s) in this order into Monthly Billing after initial payment."
                name="enrollInMonthlyBilling" id="enrollInMonthlyBilling"
                [(ngModel)]="pendingOrder.enrollInMonthlyBilling" [binary]="true"></p-checkbox>

            <br />
            <div class="ms-4 mt-2">
                I understand and agree that by checking this box, I authorize the Short Code Registry to bill the short
                code(s)
                in this order on a monthly basis following completion of their initial pre-paid term, and that the short
                codes
                will remain in Monthly Billing until I explicitly remove them. I also agree that these short code(s) are
                subject to
                the terms of the Monthly Billing Program as described in the Registrant Sublicense Agreement.
            </div>
        </div>
    </div>

    <hr />
    <h3 class="mb-4"> Agreements </h3>
    <div>
        <label for='termAgreement' class="required mt-0">
            <p-checkbox name="termAgreement" id="termAgreement" [(ngModel)]="termAgreement" [required]="true"
                #termAgreementCheckbox="ngModel" label="Terms & Conditions" [binary]="true"></p-checkbox>
        </label>
        <div class="error-msg" *ngIf="termAgreementCheckbox.touched && termAgreementCheckbox.invalid">
            <span class="failed">
                Please read the Registrant Sublicense Agreements and click on the box to accept.
            </span>
        </div>

    </div>
    <div class="ms-4 mt-2">
        I have read and accept the &nbsp;
        <a [href]="licenseAgreementcontent" target="_blank">
            Short Code Registry's Registrant Sublicense Agreement
        </a> &nbsp; (last updated {{ licenseAgreementDate }})
    </div>
    <div class="ms-4 mt-2">
    I acknowledge and agree that by clicking to accept the Registrant Sublicense Agreement that I am solely responsible for the accuracy
      and completeness of the information provided to the Short Code Registry, including without limitation my application information.
    </div>
    <br>
    <div>
        <label for='bestPractices' class="required mt-0">
            <p-checkbox name="bestPractices" id="bestPractices" [(ngModel)]="bestPractices" [required]="true"
                #bestPracticesCheckbox="ngModel" label="Best Practices" [binary]="true"></p-checkbox>
        </label>
        <div class="error-msg" *ngIf="bestPracticesCheckbox.touched && bestPracticesCheckbox.invalid">
            <span class="failed">
                Please read the Messages Principles and Best Practices document and click on the box to accept.
            </span>
        </div>

    </div>
    <div class="ms-4 mt-2">
        I have read and accept the &nbsp;
        <a [href]="bestPracticesContent" target="_blank">
            Messaging Principles and Best Practices
        </a> &nbsp; (last updated {{ bestPracticesDate }})
    </div>
    <hr />

    <div class="footer">
        <div *ngIf="!isRenew() && !isBulkRenew()" class="float-end">
            <button id="completeOrder" type="submit" class="btn btn-primary me-3" appPreventDoubleClick
                [throttleTime]="3000" (throttledClick)="submitForm($event)">
                Complete Order
            </button>
            <button id="canOrder" class="btn btn-secondary" type="button" (click)="cancelOrder()">
                {{ isPayLater() || isManualPayMonthlyBilling() ? "Cancel" : "Clear Order" }}
            </button>
        </div>
        <div *ngIf="isRenew() || isBulkRenew()" class="float-end">
            <button id="completeOrder" type="button" class="btn btn-primary me-3" appPreventDoubleClick
                [throttleTime]="700" (throttledClick)="submitForm($event)">
                Complete Renew
            </button>
            <button i18n class="btn btn-secondary" type="button" (click)="cancelOrder()" id="canOrder">
                Cancel Renew
            </button>
        </div>
    </div>
</form>

<p-confirmDialog key='canOrder' #canOrder width="425" [closable]="false" [blockScroll]="false">
    <p-footer>
        <button i18n id="canAccept" class="btn btn-primary me-2" (click)="canOrder.accept()">Yes</button>
        <button i18n id="canReject" class="btn btn-secondary" (click)="canOrder.reject()">No</button>
    </p-footer>
</p-confirmDialog>